module.exports = __webpack_public_path__ + "img/poi-marker-default.e48a5a07.png";